export default __webpack_public_path__ + "static/datos-1eaac9827fb3573b26e378d3b5d3cba6.svg";